export default __webpack_public_path__ + "static/media/ppt5_intro.24e9abc8.png";